import React from 'react';
import {
  FieldWrapper,
  FieldLabel,
  FieldTextArea,
  HelperText
} from './index.style';

export interface TextAreaFieldProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  helperText?: string;
  error?: string;
  fullWidth?: boolean;
  fieldSize?: 'sm' | 'md';
}

const TextAreaField = React.forwardRef<HTMLTextAreaElement, TextAreaFieldProps>(
  (
    {
      label,
      helperText,
      error,
      fullWidth = true,
      fieldSize = 'md',
      id,
      name,
      ...props
    },
    ref
  ) => {
    const fieldId = id || name;
    const helperId = fieldId ? `${fieldId}-helper` : undefined;
    const showHelper = Boolean(error || helperText);
    const describedBy = showHelper ? helperId : undefined;

    return (
      <FieldWrapper $fullWidth={fullWidth}>
        <FieldLabel htmlFor={fieldId}>{label}</FieldLabel>
        <FieldTextArea
          ref={ref}
          id={fieldId}
          name={name}
          aria-invalid={!!error}
          aria-describedby={describedBy}
          $hasError={!!error}
          $fullWidth={fullWidth}
          $size={fieldSize}
          {...props}
        />
        {showHelper && (
          <HelperText id={helperId} $hasError={!!error}>
            {error || helperText}
          </HelperText>
        )}
      </FieldWrapper>
    );
  }
);

TextAreaField.displayName = 'TextAreaField';

export default TextAreaField;
